import React, { useCallback, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, ModalFooter, Button, Input } from 'reactstrap';
import Spinner from './Spinner/Spinner.js';

import axios from "axios";

const listItem = {
    fontSize: '15px',
    padding: '5px'
}

const TwoFactorSetup = ({isOpen, toggleModal}) => {
    const token = localStorage.getItem('jwtToken');
    const [isLoading, setIsLoading] = useState(true);
    const [qrData, setQrData] = useState(false);

    const getUserTwoFactorQr = useCallback(async() => {
        try{
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v2/users/multi-factor-auth/qr`, {headers: {Authorization: `Bearer ${token}`}});
            setIsLoading(false);
            setQrData(response.data);
            return;
        }catch(error){
            console.log(error);
            setIsLoading(true);
            setQrData({
                success: false
            })
        }
    }, [token])

    useEffect(() => {
        getUserTwoFactorQr()
    }, [])

    if(isLoading){
       return( 
            <Spinner/>
       )
    }

    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggleModal} size='lg'>
                <ModalHeader toggle={toggleModal}>Configure two-factor authentication</ModalHeader>
                <ModalBody>
                    {((qrData && qrData.success) && ( 
                    <Row >
                        <Col md={6}>
                            <img alt='qrcode-for-2fa-app' src={`data:image/jpeg;base64,${qrData.qrCode}`} width={300} height={300}/>
                        </Col>
                        <Col md={6}>
                        <Input bsSize="lg" type="text" value={`${qrData.qrKey.toUpperCase()}`} readOnly/>
                            <br/>
                            <ol>
                                 <li style={listItem}>Download and Install <strong>Authy, Google Authenticator, or Windows Authenticator Mobile App</strong></li>
                                <li style={listItem}>Scan this barcode</li>
                                <li style={listItem}>Or manually enter the key above</li>
                            </ol>
                        </Col>  
                    </Row>
                    )) || (<h1>Error While loading data</h1>)}
                </ModalBody>
                <ModalFooter><Button size="lg" onClick={toggleModal}>Close</Button></ModalFooter>
            </Modal>
        </div>
    )
}

export default TwoFactorSetup;